package com.appsyde.contract

import kotlinx.serialization.Serializable

@Serializable
data class ErrorResponseDto(
    val code: String,
    val message: String? = null,
    val requestId: String? = null,
    val fields: Map<String, String>? = null
)